import { render, staticRenderFns } from "./InterfaceCodeEditor.vue?vue&type=template&id=a537e06e&scoped=true"
import script from "./InterfaceCodeEditor.vue?vue&type=script&lang=js"
export * from "./InterfaceCodeEditor.vue?vue&type=script&lang=js"
import style0 from "./InterfaceCodeEditor.vue?vue&type=style&index=0&id=a537e06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a537e06e",
  null
  
)

export default component.exports